var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000244141 4.12509C-0.000244141 2.26115 1.51078 0.750122 3.37471 0.750122L11.4427 0.750122C12.3377 0.750122 13.1962 1.1057 13.8291 1.73863L17.011 4.92058C17.6439 5.55351 17.9995 6.41195 17.9995 7.30704L17.9995 19.8749C17.9995 21.739 16.4886 23.2499 14.6246 23.2499L3.37471 23.2499C1.51078 23.2499 -0.000244141 21.739 -0.000244141 19.8749L-0.000244141 4.12509ZM3.37471 3.0001C2.75341 3.0001 2.24973 3.50378 2.24973 4.12509L2.24973 19.8749C2.24973 20.4962 2.75341 20.9999 3.37471 20.9999L14.6246 20.9999C15.2459 20.9999 15.7496 20.4962 15.7496 19.8749L15.7496 7.30704C15.7496 7.00868 15.6309 6.72253 15.42 6.51155L12.2381 3.3296C12.0271 3.11863 11.741 3.0001 11.4427 3.0001L3.37471 3.0001Z",
    fill: "#2D8AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37474 3.00012C2.75343 3.00012 2.24976 3.5038 2.24976 4.12511L2.24976 19.875C2.24976 20.4963 2.75343 21 3.37474 21L14.6246 21C15.2459 21 15.7496 20.4963 15.7496 19.875L15.7496 7.30706C15.7496 7.0087 15.6309 6.72255 15.42 6.51157L12.2382 3.32962C12.0271 3.11865 11.741 3.00012 11.4427 3.00012L3.37474 3.00012Z",
    fill: "#2D8AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1247 14.1L4.87475 14.1C4.66774 14.1 4.49976 13.6296 4.49976 13.05C4.49976 12.4704 4.66774 12 4.87475 12L10.1247 12C10.3317 12 10.4997 12.4704 10.4997 13.05C10.4997 13.6297 10.3317 14.1 10.1247 14.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5309 17.1L4.9685 17.1C4.70974 17.1 4.49976 16.6296 4.49976 16.05C4.49976 15.4704 4.70974 15 4.9685 15L11.5309 15C11.7897 15 11.9997 15.4704 11.9997 16.05C11.9996 16.6296 11.7897 17.1 11.5309 17.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9998,
    height: 22.4998,
    fill: "white",
    transform: "translate(-0.000244141 0.750122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIconBlue);
export default __webpack_public_path__ + "static/media/WordIconBlue.819d361b215f98a35f9eff71e7b06d74.svg";
export { ForwardRef as ReactComponent };